/** @module csi/skintheme/StarryNight */
define([], function() {
	return {
		Blue1: "Blue30",
		Blue2: "Blue50",
		Blue3: "Blue500",

		PrimaryBlue: "Blue600",
		PrimaryDisabledColor: "Blue200",
		PrimaryColor2: "Blue700",
		PrimaryColor3: "Blue900",

		SiteHeaderBackground: "Black200",

		CompanyHeaderBlue1: "Black200",
		CompanyHeaderBlue2: "Black400",

		/* LINK */
		LinkNormal: "Blue600",
		LinkHover: "Blue800",
		LinkActive: "Blue600",

		/* Comment */
		CommentActiveColor: "Blue600",

		/** custom view */
		CustomViewOptionActiveColor: "Blue500",

		/* FULL SCREEN HEADER */
		FullScreenHeaderBackgroundColor: "Black200",
		FullScreenLogoBackgroundColor: "Black200",

		/* TEXT */
		TabsTextActive: "PrimaryBlue",

		/* Button */
		BtnPrimaryFocusedBorderColor: "Blue900",
		ButtonSwitchNormalIconStateOnBackgroundColor: "Blue600",

		/* BreadCrumb */
		BreadcrumbNormalLinkColor: "Blue600",

		/* CheckBox */
		CheckBoxFocusColor: "Blue300",

		/* Text Border */
		TextfieldActiveBorderColor: "PrimaryColor",
		BtnToolbarFocusedBorderColor: "PrimaryColor",

		/* DropDown */
		DropdownSelectActiveBorderColor: "PrimaryColor",

		/* Header */
		LastVisitedBackgroundColor: "PrimaryWhite",
		LastVisitedIconColor: "SiteHeaderBackground",
		PageHeaderButtonTextColor: "PrimaryWhite",
		PageHeaderToolbarIconColor: "PrimaryWhite",
		PageHeaderToolbarHoverColor: "PrimaryWhite",
		PageHeaderSearchInButtonHoverColor: "BtnSecondaryHoverBackgroundColor",
		PageHeaderToolbarSeparatorColor: "WhiteOpacity20",
		PageHeaderSearchScopeBackgroundColor: "BtnSecondaryNormalBackgroundColor",
		PageHeaderSearchBlockBackgroundColor: "TextfieldNormalBackgroundColor",
		CompanyLogoTextColor: "WhiteTextColor",
		CompanyLogoImageURL: "DarkCompanyLogoIconURL",
		ExitFullScreenIconURL: "DarkExitFullScreenIconURL",

		/* Table */
		TableCopyBorderColor: "Blue600",
		TablePasteBorderColor: "Blue600",
		TableNewRowBackgroundColor: "Blue100",

		/* Slicer */
		SlicerMetricsBackgroundColor: "Blue100",

		/* Chart */
		ChartAreaURL: "ChartAreaBlueURL",
		ChartBarURL: "ChartBarBlueURL",
		ChartColumnURL: "ChartColumnBlueURL",
		ChartDoughnutURL: "ChartDoughnutBlueURL",
		ChartLineURL: "ChartLineBlueURL",
		ChartMsAreaURL: "ChartMsAreaBlueURL",
		ChartMsBarURL: "ChartMsBarBlueURL",
		ChartMsColumnURL: "ChartMsColumnBlueURL",
		ChartMsLineURL: "ChartMsLineBlueURL",
		ChartParetoURL: "ChartParetoBlueURL",
		ChartPieURL: "ChartPieBlueURL",
		ChartStackedAreaURL: "ChartStackedAreaBlueURL",
		ChartStackedBarURL: "ChartStackedBarBlueURL",
		ChartStackedColumnURL: "ChartStackedColumnBlueURL",

		/* Progress bar */
		ProgressBarDeterminateProgressColor: "PrimaryColor",

		HighlightSelected: "Grey200"
	};
});